











import {
  defineComponent,
  ref,
  watch,
  PropType,
  onBeforeUnmount,
  nextTick,
} from '@nuxtjs/composition-api'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'
import { BackdropOverlayZIndex } from '~/composables/ui/useBackdropOverlay'

export default defineComponent({
  name: 'BaseBackdropOverlay',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: String as PropType<BackdropOverlayZIndex>,
      default: BackdropOverlayZIndex.Z10,
    },
    lockScroll: {
      type: Boolean,
      default: true,
    },
    fade: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const overlayEl = ref<HTMLElement | null>(null)

    watch(
      () => props.visible,
      (visible, oldVisible) => {
        if (process.client) {
          if (visible) {
            if (props.lockScroll) {
              disablePageScroll(document.querySelector('body'))
            }
            if (props.appendToBody) {
              nextTick(() => {
                if (overlayEl.value) {
                  document.body.appendChild(overlayEl.value)
                }
              })
            }
          }
          // Note: do this only when overlay from active to inactive
          if (oldVisible && !visible) {
            if (props.lockScroll) {
              enablePageScroll(document.querySelector('body'))
            }
            if (props.appendToBody) {
              nextTick(() => {
                if (overlayEl.value?.parentNode) {
                  overlayEl.value.parentNode.removeChild(overlayEl.value)
                }
              })
            }
          }
        }
      },
      {
        immediate: true,
      }
    )

    // Note: ensure enable page scroll after router back when backdrop overlay is active
    onBeforeUnmount(() => {
      enablePageScroll(document.querySelector('body'))
      if (overlayEl.value?.parentNode) {
        overlayEl.value.parentNode.removeChild(overlayEl.value)
      }
    })

    return {
      overlayEl,
    }
  },
})
